import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Add global test helper for notifications
(window as any).testNotifications = () => {
  console.log('🔔 Testing notifications...');
  console.log('To generate demo notifications, use in console:');
  console.log('1. Get your user ID from localStorage or Firebase');
  console.log('2. const demo = new DemoNotifications("your-user-id")');
  console.log('3. demo.generateAll()');
  console.log('');
  console.log('Quick test - adding a notification with a test user ID:');
  const testUserId = localStorage.getItem('lastUserId') || 'test-user-123';
  console.log('Using user ID:', testUserId);
  
  if ((window as any).notificationService) {
    (window as any).notificationService.addNotification(testUserId, {
      type: 'deal_alert',
      priority: 'high',
      title: '🔥 Test Notification',
      message: 'This is a test notification created at ' + new Date().toLocaleTimeString(),
      dismissible: true,
      persistent: true,
    });
    console.log('✅ Test notification added! Check the bell icon.');
    
    // Show unread count
    const unread = (window as any).notificationService.getUnreadCount(testUserId);
    console.log(`📊 Unread count: ${unread}`);
  } else {
    console.error('❌ notificationService not available');
  }
};

console.log('🔔 Notification test helper loaded! Run testNotifications() in console to test.');
